import { combineReducers } from 'redux';
import transactionReducer from './reducers/transactionSlice';
import rfqManageSlice from './reducers/rfqSlice';
import facilitySlice from './reducers/facilitySlice';
import userManagementSlice from './reducers/userManagementSlice';
import eventsSlice from './reducers/eventsSlice';
import requestSlice from './reducers/requestSlice';
import dashboardReducer from './reducers/dashboardReducer';
import iamReducer from './reducers/iamSlice';
import tradeSupportReducer from './reducers/tradeSupportSlice';

const appReducers = combineReducers({
    transaction: transactionReducer,
    rfqMang: rfqManageSlice,
    facility: facilitySlice,
    userMang: userManagementSlice,
    events: eventsSlice,
    request: requestSlice,
    dashboard: dashboardReducer,
    iam: iamReducer,
    tradeSupport: tradeSupportReducer,
});

const rootReducer = combineReducers({
    app: appReducers,
});

export default rootReducer;
